import React from "react";
import MissedActivityStudents from "../../../containers/admin/students/missedActivityStudents";

const MissedActivity = () => <MissedActivityStudents />;

export default MissedActivity;
